module.exports = "/_next/static/images/DebugYourData@2x-2f93034bb8a9aa01a47caea7817c6776.webp";